module.exports = __webpack_public_path__ + "static/img/empty.736e0bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/content-layout/assets/img/empty.svg
// module id = gZjz
// module chunks = 95